export default function SvgWhatsApp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 25}
      height={props.height || 24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2882_16740)">
        <path
          d="M20.9054 4.19687C18.6607 2.13437 15.6714 1 12.4946 1C5.9375 1 0.601786 5.89107 0.601786 11.9018C0.601786 13.8219 1.14821 15.6978 2.1875 17.3527L0.5 23L6.80536 21.4826C8.54107 22.3518 10.4964 22.8085 12.4893 22.8085H12.4946C19.0464 22.8085 24.5 17.9174 24.5 11.9067C24.5 8.99464 23.15 6.25937 20.9054 4.19687ZM12.4946 20.9719C10.7161 20.9719 8.975 20.5348 7.45893 19.7098L7.1 19.5134L3.36071 20.4121L4.35714 17.0679L4.12143 16.7241C3.13036 15.2804 2.61071 13.6156 2.61071 11.9018C2.61071 6.90759 7.04643 2.84152 12.5 2.84152C15.1411 2.84152 17.6214 3.78437 19.4857 5.49821C21.35 7.21205 22.4964 9.48571 22.4911 11.9067C22.4911 16.9058 17.9429 20.9719 12.4946 20.9719ZM17.9161 14.1853C17.6214 14.0478 16.1589 13.3897 15.8857 13.3013C15.6125 13.208 15.4143 13.1638 15.2161 13.4388C15.0179 13.7138 14.45 14.3228 14.2732 14.5094C14.1018 14.6911 13.925 14.7156 13.6304 14.5781C11.8839 13.7777 10.7375 13.1491 9.58571 11.3371C9.28036 10.8558 9.89107 10.8902 10.4589 9.84911C10.5554 9.66741 10.5071 9.51027 10.4321 9.37277C10.3571 9.23527 9.7625 7.89464 9.51607 7.34955C9.275 6.8192 9.02857 6.89286 8.84643 6.88304C8.675 6.87321 8.47679 6.87321 8.27857 6.87321C8.08036 6.87321 7.75893 6.94196 7.48571 7.21205C7.2125 7.48705 6.44643 8.14509 6.44643 9.48571C6.44643 10.8263 7.5125 12.1228 7.65714 12.3045C7.80714 12.4862 9.75179 15.2362 12.7357 16.4196C14.6214 17.1661 15.3607 17.2299 16.3036 17.1022C16.8768 17.0237 18.0607 16.4442 18.3071 15.8058C18.5536 15.1674 18.5536 14.6223 18.4786 14.5094C18.4089 14.3866 18.2107 14.3179 17.9161 14.1853Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2882_16740">
          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
